/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-04-24 18:46:56
 * @FilePath: /insuranceagent-ui/src/mixins/mixinsSettleInfo.js
 */
import {getMyContractList} from '@/api/insurance/contractManage'
import {SettleType} from '@/const/enum'
import {isSettlePrivate as isSettlePrivateFn, isSettleTypeSame} from '@/util/settleUtils'
import {rule} from '@/util/validateRules'
import {decryptMessageByArray} from '@/util/secret'
import {settleInfoPrivateOption, settleInfoPublicOption, settleSettingOption} from '@/const/crud/settlement/applyOption'
import {isMainChannel} from '@/util/channelUtil'
import {getContractList} from '@/api/insurance/contractManage'

export const mixinsSettleInfo = {
	data() {
		return {
			settleInfoOption: {},
			saveContractList: [],
			saveDiffSettleAccounts: [],
			disAbledEditKeys: ['userName', 'idNo'],
		}
	},
	computed: {
		//判断是否为对私支付
		isSettlePrivate() {
			//解构
			let {settleType = ''} = this.formData
			return !settleType || isSettlePrivateFn(settleType)
		},
		//判断是否为代理人佣金
		isSettleAgent() {
			let {settleType = ''} = this.formData
			return settleType === SettleType.AGENT
		},
		//判断是否为第三方清分
		isSettlePrivateThird() {
			let {settleType = ''} = this.formData
			return settleType === SettleType.PRIVATE
		},
		//是否可以编辑
		isShowAddBtn() {
			let {settleType = ''} = this.formData
			//只有对私里的第三方清分才可以编辑
			return settleType === SettleType.PRIVATE
		},
	},
	methods: {
		/**
		 * 通过结算信息，和代理人数据，进行过滤
		 * @param {*} settleInfoList
		 */
		async filterSettleInfo(settleAccounts = [], settleType = '') {
			try {
				this.saveDiffSettleAccounts = []
				//先过滤对公或者对私一类的
				let tempSettleAccounts = []
				for (const itemData of settleAccounts) {
					let {type = ''} = itemData
					if (!isSettleTypeSame(type, settleType)) {
						this.saveDiffSettleAccounts.push(itemData)
					} else {
						tempSettleAccounts.push(itemData)
					}
				}
				settleAccounts = tempSettleAccounts
				//如果结算方式为代理人佣金，则再次请求数据
				if (settleType === SettleType.AGENT) {
					//获取代理人信息
					await this.getMyContractDataList()
					// 根据contractList数据中的 idNo 和 settleAccounts中的 idNo 对比，
					// 只保留 settleAccounts中 idNo 在 contractList中的数据
					settleAccounts = settleAccounts.filter((itemData) => {
						let result = this.saveContractList.some((contractItem) => itemData.idNo === contractItem.idNo)
						if (!result) {
							this.saveDiffSettleAccounts.push(itemData)
						}
						return result
					})
					// this.saveContractList 中 idNo 在 settleAccounts 中不存在的数据，则加入到 settleAccounts 中
					for (const itemData of this.saveContractList) {
						let {idNo = ''} = itemData
						let result = settleAccounts.some((contractItem) => idNo === contractItem.idNo)
						if (!result) {
							settleAccounts.push(itemData)
						}
					}
				}
				return settleAccounts
			} catch (error) {
				throw error
			}
		},

		/**
		 * 获取代理人信息
		 */
		async getMyContractDataList() {
			if (this.saveContractList.length <= 0) {
				//区分主渠道还是管理员
				let contractList = []
				if (isMainChannel()) {
					let resMy = await getMyContractList()
					let {data: contractListTemp = []} = resMy.data || {}
					contractList = contractListTemp
				} else {
					//pageNo=1&page=1&pageSize=20&current=1&size=20&userId=
					let {id: userId = ''} = this.formData
					if (userId) {
						let resContract = await getContractList({
							pageNo: 1,
							page: 1,
							pageSize: 20,
							current: 1,
							size: 20,
							userId,
						})
						let {records = []} = resContract.data.data || {}
						contractList = records
					}
				}
				//解密
				contractList = await decryptMessageByArray(contractList)
				//根据状态 status:VERIFY_SUCCESS 的合同，进行过滤
				contractList = contractList.filter((item) => item.status === 'VERIFY_SUCCESS')
				if (contractList.length <= 0) {
					if (isMainChannel()) {
						//主渠道直接报错
						this.settleInfoList = null
						throw new Error('请先签订合同，再进行结算设置！')
					} else {
						//提示
						//管理员要清除掉结算方式，并且不能选择代理人
						this.$alert('渠道结算方式为代理人佣金，请先签订合同，再进行结算设置！').then(() => {
							//禁止选择代理人佣金
							this.onHandleAgentSettle()
						})
					}
				}
				contractList = contractList.map((item) => {
					let {
						idNo = '',
						name = '',
						mobile = '',
						bankCity = '',
						bankName = '',
						cardNo = '',
						cardFrontUrl = '',
						cardBackUrl = '',
					} = item
					return {
						idNo,
						userName: name,
						settleType: SettleType.AGENT,
						mobile,
						bankCity,
						bankName,
						cardNo,
						cardFrontUrl,
						cardBackUrl,
						idType: '身份证',
					}
				})
				this.saveContractList = contractList
			}
		},

		/**
		 * 设置结算信息option
		 */
		onSetSettleInfoOption(newVal, isChannel = false) {
			//区分对公还是对私  PUBLIC  PRIVATE
			//如果是对公处理显示的
			if (!this.isSettlePrivate) {
				this.settleInfoOption = this.deepClone(settleInfoPublicOption)
				//对公只有month
				this.formData.settlePeriod = 'MONTH'
			} else {
				this.settleInfoOption = this.deepClone(settleInfoPrivateOption)
				//处理身份证
				this.onSettleAgeControl(newVal)
			}
			//处理options
			this.onSetOptions(isChannel)
		},

		/**
		 * 对私 处理options
		 */
		onSetOptions(isChannel = false) {
			//处理对私结算年龄代理人佣金，不限制
			this.settleInfoOption.column.forEach((item) => {
				let {prop = ''} = item
				if (prop === 'userName') {
					item.label = this.isSettlePrivate ? '结算人' : '企业全称'
				}
				//代理人佣金不能编辑姓名和身份证， 对公结算前端用户禁止编辑
				if ((this.disAbledEditKeys.includes(prop) && this.isSettleAgent) || (isChannel && !this.isSettlePrivate)) {
					item.disabled = true
				}
				//运营后台管理隐藏掉身份证图片 cardFrontUrl 和 cardBackUrl
				if (!isChannel) {
					if (prop === 'cardFrontUrl' || prop === 'cardBackUrl') {
						item.rules = []
					}
				}
				if (prop === 'del') {
					item.display = !isChannel && this.isSettlePrivateThird
				}
			})
		},

		//处理结算年龄控制
		onSettleAgeControl(newVal) {
			//结算身份证年龄控制
			let tempIdNo = this.findObject(this.settleInfoOption.column, 'idNo')
			if (tempIdNo) {
				const tempRules = [
					{
						required: true,
						message: '请输入 身份证号',
						trigger: 'blur',
					},
					{
						validator: rule.validatorIdNo,
						trigger: 'blur',
					},
				]
				if (newVal === SettleType.AGENT) {
					tempIdNo.rules = tempRules
				} else if (newVal === SettleType.PRIVATE) {
					tempIdNo.rules = [
						...tempRules,
						{
							validator: rule.validatorIdNoOld,
							trigger: 'blur',
						},
					]
				}
			}
		},
	},
}
